import { isValidPhoneNumber } from "libphonenumber-js";
import * as yup from "yup";

export const contact_schema = {
  name: "",
  email: "",
  phone: "",
  request_type: "",
  subject: "",
  description: "",
};

export const contact_validation_schema = yup.object().shape({
  name: yup.string().required("name_required"),
  email: yup.string().email("invalid_email").required("email_required"),
  phone: yup
    .string()
    .required('number_required')
    .test(
      'is-valid-phone',
      'invalid_phone_no',
      (value) => {
        if (!value) return false;
        return isValidPhoneNumber(value);
      }
    ),
  request_type: yup.object().required("request_type_required"),
  subject: yup.string().required("subject_required"),
  description: yup.string().required("description_required"),
});
